import SectionContentWrapper from "@/components/Shared/SectionContentWrapper";
import styled from "styled-components";

export default function TitleWithDescription({ sectionTitle, theme }) {
  return <SectionContentWrapper sectionTitle={sectionTitle} theme={theme} />;
}
